var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAisStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 320 297",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 148.5C316.5 228.34 246.683 293.5 160 293.5C73.317 293.5 3.5 228.34 3.5 148.5C3.5 68.66 73.317 3.5 160 3.5C246.683 3.5 316.5 68.66 316.5 148.5Z",
    stroke: "black",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 20H180.5V247H153.5V20Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 257,
    width: 23,
    height: 18,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.823 150.68C135.394 151.078 135.394 151.922 134.823 152.32L76.0718 193.273C75.4089 193.735 74.5 193.26 74.5 192.452V110.548C74.5 109.74 75.4089 109.265 76.0718 109.727L134.823 150.68Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAisStartIcon);
export default __webpack_public_path__ + "static/media/ais-start-icon.f8e5c29f2c522e0bc4f87bfa3c6871f9.svg";
export { ForwardRef as ReactComponent };